function toggleMute() {
    var bcPlayer = videojs.getPlayer('v'); // Get the video player object
    bcPlayer.muted(!bcPlayer.muted()); // Toggle the mute state

    const icon = document.querySelector('.inner');
    icon.style.display = 'none'; // Hides the icon
  }